import React from 'react';
import { Box, Divider, List, ListItem, Typography, Grid, IconButton } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';
import { PossibleQuestion, ResponseLabels } from '../../../interfaces/surveyScreen';
import RatingButtons from '../../../common/RatingButtons/ViewAllRatingButtons';
import LazyLoad from 'react-lazy-load';
import { ViewAllStyles } from '../../../styles/ViewAllScreenStyles';

interface ImportanceRatingSectionProps {
  importanceRatingQuestions: PossibleQuestion[];
  IRlabels: ResponseLabels[];
  isValidating: boolean;
  QUSecLength: number;
  updateResponse: (data: string, qseq?: number | string) => Promise<string>;
  handleClick: (event: React.MouseEvent<HTMLElement>, question: PossibleQuestion, isComp?: boolean) => void;
}

const ImportanceRatingSection = ({
  importanceRatingQuestions,
  IRlabels: labels,
  QUSecLength,
  isValidating,
  updateResponse,
  handleClick,
}: ImportanceRatingSectionProps): React.JSX.Element => {
  const { classes } = ViewAllStyles();

  const onAnswer = React.useCallback((data: string, qseq?: number | string): void => {
    updateResponse(data, qseq);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <List>
      {importanceRatingQuestions &&
        importanceRatingQuestions.map((ques: PossibleQuestion, id: number) => {
          return (
            <LazyLoad key={`${ques.itemID || ques.itemId}_${ques.scaleId}`} offset={1000}>
              <ListItem key={`${ques.itemID || ques.itemId}_${ques.scaleId}`} className={classes.listStyle}>
                <Box className={classes.listItem}>
                  <Divider className={classes.divider} aria-hidden="true" />
                  <Box className={classes.questionBlock}>
                    <Grid container>
                      <Grid item lg={5} sm={12}>
                        <div className={classes.question}>
                          <IconButton
                            className={classes.competencyHelpIcon}
                            aria-hidden={true}
                            onClick={(event): void => handleClick(event, ques, true)}
                            data-testid={`openCompHelp${id}`}>
                            <HelpOutline fontSize="small" />
                          </IconButton>
                          <Typography className={classes.font1rem}>{ques.competencyName}</Typography>
                        </div>
                      </Grid>
                      <Grid item lg={7} sm={12} className={classes.marginAuto}>
                        <RatingButtons
                          qseq={QUSecLength + id + 1}
                          labels={labels}
                          selectedResponse={ques.selectedResponse}
                          hasNoEvidence={ques.hasNoEvidence}
                          onAnswer={onAnswer}
                          isValidating={isValidating}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                  <Divider
                    aria-hidden="true"
                    className={`${
                      id === importanceRatingQuestions.length - 1 ? classes.finalDivider : classes.displayNone
                    } ${classes.divider}`}
                  />
                </Box>
              </ListItem>
            </LazyLoad>
          );
        })}
    </List>
  );
};

export default ImportanceRatingSection;
